
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/atsiskaitymas-2",
      function () {
        return require("private-next-pages/lt/atsiskaitymas-2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/atsiskaitymas-2"])
      });
    }
  